import OrderService from '../service/order'

export default {
  name: 'Search',
  props: {
    place: Object
  },
  data() {
    return {
       api_url: process.env.VUE_APP_URL_API,
       code: '',
       searching: false,
       orderNotFound: false,
       orders: [],
       topics: [],
       subscriptions: []
    }
  },
  watch: {
    place: {
      // the callback will be called immediately after the start of the observation
      immediate: true, 
      handler () {
        if (this.place.order_search) {
          this.code = this.place.order_search
          this.searchOrder()
        }
      }
    }
  },
  methods : {
    searchOrder() {
      this.orderNotFound = false
      this.searching = true
      if (this.code == '') {
        return
      }
      OrderService.search(this.code, 
        this.place.place_id, 
        (this.place.search_by_client ? this.place.client_id : null),
        (this.place.use_description ? this.place.use_description : null)
      ).then(response => {
        this.searching = false
        if (!response) {
          this.orderNotFound = true
        } else {
          let exist = false
          if (this.orders.length > 0 && response.orderId) {
            for (let o in this.orders) {
              if (this.orders[o].orderId === response.orderId) {
                this.orders[o] = response
                exist = true
              }
            }
          }
          if (!exist) {
            this.orders.push(response)
            if (response.placeId) {
              this.subscribe(response.placeId)
            }
          }
        }
      })
    },
    refresStatus() {
      if (this.orders.length > 0) {
        this.searching = true
        for (let o in this.orders) {
          let code = this.orders[o].externalDeliveryId ? this.orders[o].externalDeliveryId : this.orders[o].orderId
          OrderService.search(code, 
            this.place.place_id,
            (this.place.search_by_client ? this.place.client_id : null),
            (this.place.use_description ? this.place.use_description : null)
          ).then(response => {
            if (!response) {
              // this.orders.splice(o, 1)
            } else {
              this.orders[o] = response
              this.orderStatus(this.orders[o])
              this.alertOrder(this.orders[o])
              this.alertSound(this.orders[o])
            }
            if ((parseInt(o)+1) === this.orders.length) {
              this.searching = false
            }
          })
        }
      }
    },
    buildTopic(placeId) {
      return 'net.waitry.ws.'+ process.env.VUE_APP_WAMP_PREFIX + 'place.' + placeId
    },
    subscribe(placeId) {
      let topic = this.buildTopic(placeId)
      if (!this.topics.includes(topic)) {
        this.topics.push(topic)
        this.$wamp.subscribe(topic, this.evaluateStatus, {
            acknowledge: true
        }).then(this.registerSession)
      }
    },
    registerSession(session) {
      this.subscriptions.push(session)
      console.log('Wamp subscribe: ', session.topic)
    },
    unsubscribe(placeId) {
      let topic = this.buildTopic(placeId)
      if (!this.topics.includes(topic)) {
        return
      }
      this.topics.splice(this.topics.indexOf(topic), 1)
      let topicSession = this.subscriptions.find(se => se.topic === topic)
      if (topicSession) {
        this.$wamp.unsubscribe(topicSession)
        this.subscriptions.splice(this.subscriptions.indexOf(topicSession), 1)
        console.log('Wamp unsubscribe', topic)
      }
    },
    evaluateStatus(notif) {
      console.log('notif', notif)
      if (!notif.length || (!notif[0].orderId && !notif[0].order_id) || !this.orders.length) {
        return
      }
      let orderId = notif[0].orderId ? notif[0].orderId : notif[0].order_id
      for (let o in this.orders) {
        if (this.orders[o].orderId == orderId) {
          this.orders[o].status = notif[0].new_status ? notif[0].new_status : notif[0].event ? notif[0].event : this.orders[o].status
          this.orderStatus(this.orders[o])
          this.alertOrder(this.orders[o])
          this.alertSound(this.orders[o])
        }
      }
    },
    orderStatus: function (order) {
      return this.place.status_detail || order.status == 'closed' ? order.status : order.status == 'delivered' || order.status == 'order_delivered' ? 'delivered' : 'progress'
    },
    alertOrder: function (order) {
      return order.status == 'delivered' || order.status == 'order_delivered' ? 'animated bounce repeat-5' : ''
    },
    alertSound(order) {
      if (order.status == 'delivered' || order.status == 'order_delivered') {
        var audio = new Audio(require('../assets/sounds/desk_bell.mp3'))
        audio.play()
      }
    },
    closeNotFound() {
      this.orderNotFound = false
    },
    discard(index) {
      if (index >= 0) {
        let keepTopic = false
        let placeId = this.orders[index].placeId
        for (let o in this.orders){
          if(o != index && this.orders[o].placeId == placeId) {
            keepTopic = true
          }
        }
        if (!keepTopic){
          this.unsubscribe(placeId)
        }
        this.orders.splice(index, 1)
      }
    },
    translate(status) {
      let statusES = ''
      // si el place no quiere mostrar todos los estados, se muestran solo dos 
      if (!this.place.status_detail) {
        return status === 'delivered' || status === 'order_delivered' ? 'Listo para recoger' : status == 'closed' ? 'Finalizado' : 'Preparación'
      }

      switch (status) {
        case 'new': {
          statusES = 'Espera'
          break
        }
        case 'order_accepted':
        case 'accepted': {
          statusES = 'Aceptado'
          break
        }
        case 'order_in_progress':
        case 'progress':
        case 'in_progress': {
          statusES = 'En progreso'
          break
        }
        case 'order_ready':
        case 'ready': 
        case 'prepaired': {
          statusES = 'Preparado'
          break
        }
        case 'order_delivered':
        case 'delivered': {
          statusES = 'Entregado'
          break
        }
        case 'order_ended':
        case 'closed': {
          statusES = 'Finalizado'
          break
        }
        case 'order_canceled':
        case 'canceled': {
          statusES = 'Cancelado'
          break
        }
        case 'order_placed':
        case 'placed':
        case 'queued': {
          statusES = 'En espera'
          break
        }
        case 'order_packaging':
        case 'packaging': {
          statusES = 'Empaquetado'
          break
        }
        default: {
          statusES = status
        }
      }
      return statusES
    }
  }
}